import React, { Component } from "react";
import Select from "react-select";
import ArrowSelect from "../../images/arrow-select.svg";

const colorPrimary = "#3bb2e8";

const IndicatorsContainer = () => (
  <img src={ArrowSelect} width="24px" height="24px" />
);

export default class SelectComponent extends Component {
  state = {
    selectedOption: null
  };

  constructor(props) {
    super(props);
  }
  handleChange = selected => {
    if (this.props.onChange) {
      this.props.onChange(selected);
    }
  };

  render() {
    const {
      className,
      selected,
      options = [],
      placeholder = "โปรดระบุ",
      menuPosition,
      isMulti,
      disabled,
      closeMenuOnSelect
    } = this.props;
    return (
      <Select
        className={`select-wrapper ${className}`}
        components={{ ClearIndicator: null, IndicatorsContainer }}
        placeholder={placeholder}
        value={selected}
        isMulti={isMulti}
        isDisabled={disabled}
        closeMenuOnSelect={closeMenuOnSelect}
        menuPlacement={"auto"}
        menuPosition={menuPosition}
        onChange={this.handleChange}
        styles={{
          control: (styles, res) => {
            return {
              ...styles,
              borderRadius: "22px",
              paddingLeft: "9px",
              paddingRight: "12px",
              boxShadow: "none",
              borderColor: res.menuIsOpen ? colorPrimary : "#e1e3e5",
              backgroundColor: res.isDisabled ? '#f5f5f6' : styles.backgroundColor
            };
          },
          input: base => ({
            ...base,
            height: "38px",
            margin: "0px",
            marginTop: "2px",
            padding: "0px",
            lineHeight: 1.3
          }),
          placeholder: base => ({
            ...base,
            marginTop: "2px",
            fontSize: "16px",
            color: "#8b9299",
            lineHeight: 1.3,
            whiteSpace: "pre"
          }),
          option: (styles, { isSelected }) => {
            return {
              ...styles,
              border: "1px solid #f8f8f8",
              backgroundColor: isSelected ? colorPrimary : null,
              color: isSelected ? "#fff" : styles.color
            };
          },
          menu: base => ({
            ...base,
            marginTop: "4px"
          }),
          menuList: base => {
            return {
              ...base,
              marginTop: "0px",
              paddingBottom: "0px",
              paddingTop: "0px",
              border: `1px solid ${colorPrimary}`,
              boxShadow: "2px 2px 8px 0 rgba(155, 163, 169, 0.2)"
            };
          },
          multiValue: base => {
            return {
              ...base,
              backgroundColor: "#11488e",
              color: "#fff",
              borderRadius: "6px",
              padding: "3px 4px 3px 8px"
            };
          },
          multiValueLabel: base => {
            return {
              ...base,
              color: "#fff",
              fontSize: "12px",
              fontWeight: "normal",
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: "normal",
              letterSpacing: "normal"
            };
          },
          multiValueRemove: base => {
            return {
              ...base,
              ":hover": {
                backgroundColor: "#11488e",
                color: "#fff"
              }
            };
          }
        }}
        options={options}
      />
    );
  }
}
